import { render, staticRenderFns } from "./NotificationSidePanel.vue?vue&type=template&id=faf30eb8&scoped=true"
import script from "./NotificationSidePanel.vue?vue&type=script&lang=js"
export * from "./NotificationSidePanel.vue?vue&type=script&lang=js"
import style0 from "./NotificationSidePanel.vue?vue&type=style&index=0&id=faf30eb8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faf30eb8",
  null
  
)

export default component.exports